export default function formatTileValue(value: number): string {
  if (!Number.isFinite(value) || value < 0) return '00';
  if (value > 99) return '99';
  return value < 10 ? `0${value}` : value.toString();
}
